var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.15576 2.75C1.15576 2.33579 1.49155 2 1.90576 2H4.90576C5.255 2 5.55802 2.24106 5.63656 2.58136L5.99944 4.15385H21.9058C22.1373 4.15385 22.3559 4.26081 22.498 4.44365C22.6401 4.62649 22.6897 4.86472 22.6325 5.0891L20.6325 12.9353C20.5478 13.2675 20.2486 13.5 19.9058 13.5H8.15624L8.5024 15H19.9058C20.32 15 20.6558 15.3358 20.6558 15.75C20.6558 16.1642 20.32 16.5 19.9058 16.5H7.90576C7.55652 16.5 7.2535 16.2589 7.17497 15.9186L4.30913 3.5H1.90576C1.49155 3.5 1.15576 3.16421 1.15576 2.75ZM7.81009 12H19.323L20.9406 5.65385H6.34559L7.81009 12Z",
    className: "Icon-fill-color"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90576 20.25C10.1819 20.25 10.4058 20.0261 10.4058 19.75C10.4058 19.4739 10.1819 19.25 9.90576 19.25C9.62962 19.25 9.40576 19.4739 9.40576 19.75C9.40576 20.0261 9.62962 20.25 9.90576 20.25ZM9.90576 21.75C11.0103 21.75 11.9058 20.8546 11.9058 19.75C11.9058 18.6454 11.0103 17.75 9.90576 17.75C8.80119 17.75 7.90576 18.6454 7.90576 19.75C7.90576 20.8546 8.80119 21.75 9.90576 21.75Z",
    className: "Icon-fill-color"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9058 20.25C18.1819 20.25 18.4058 20.0261 18.4058 19.75C18.4058 19.4739 18.1819 19.25 17.9058 19.25C17.6296 19.25 17.4058 19.4739 17.4058 19.75C17.4058 20.0261 17.6296 20.25 17.9058 20.25ZM17.9058 21.75C19.0103 21.75 19.9058 20.8546 19.9058 19.75C19.9058 18.6454 19.0103 17.75 17.9058 17.75C16.8012 17.75 15.9058 18.6454 15.9058 19.75C15.9058 20.8546 16.8012 21.75 17.9058 21.75Z",
    className: "Icon-fill-color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/ShoppingCart.5259bf0fae360afdc778988393a7906f.svg";
export { ForwardRef as ReactComponent };